<div class="success-box o-vr_x3">
    <em class="material-icons">check_circle</em>
    <span>Kit # {{ kitNumber }} has been assigned to your user ID ({{ getLabAffiliationLabel(lab) }}).</span>
</div>
<div class="success-box o-vr_x3" style="background-color: #d9edf7;">
    <em class="material-icons" style="color:#009bbf;">error</em>
    <span>Your credit has been submitted for processing.</span>
</div>

<div class="actions-container">
    <button class="c-btn-full" type="submit" (click)="proceedToClaimCredit()">View CME/CE Certificate</button>
    <button class="c-btn-link" type="submit" (click)="backToClaimCmeCe()">
        Back to Claim CME/CE Credit for Faxed AP Results
    </button>
</div>
